export default __webpack_public_path__ + "static/media/prevArrow.261f9b49.svg";